import { useLocation } from 'react-router-dom';

import { IFigurant, KeyTypeFigurant, StatusFigurant } from 'models';

import { useFigurantCard } from './hooks/useFigurantCard';
import { KeySrcTypes, SRC_TYPES } from './@types';
import { Popover } from './Popover';

import { Header } from './components/Header';
import { MainContent } from './components/MainContent';
import { ActionBottom } from './components/ActionBottom';
import * as S from './styles';
import { useEffect, useState } from 'react';
import { getAttachmentsBgActor } from '../UploadPhotos/usePresignedUrl';
import { IAttachment } from '../UploadPhotos/types';

type Props = {
  src?: KeySrcTypes;
  item: StatusFigurant;
  type: KeyTypeFigurant;
  handleStatusFigurant?: (item: StatusFigurant | null) => void;
  handleSelectedFigurant?: (item: StatusFigurant) => void;
  selected?: boolean;
  handleAssociateChild?: (item: IFigurant | null) => void | undefined;
  isAvailableToAssociateChild?: boolean;
  areAllSelected?: boolean;
};

export const FigurantCard = ({
  src,
  item,
  type,
  handleStatusFigurant,
  handleSelectedFigurant,
  selected = false,
  handleAssociateChild,
  areAllSelected,
}: Props) => {
  const [attachments, setAttachments] = useState<IAttachment[]>([]);
  const { pathname } = useLocation();

  const {
    submitBySrc,
    colorUnavailableFigurant,
    figurantCpf,
    isAvailableToShowSelectButton,
    isDisabled,
    name,
    statusColor,
    isTextAvailable,
    colorSelectedFigurant,
    figurantUnavailable,
    showBlock,
    updated_at,
    missingInformation,
    extraUnavailable,
    cardType,
    renderInfo,
  } = useFigurantCard({
    item,
    type,
    selected,
    handleSelectedFigurant,
    handleAssociateChild,
    areAllSelected,
    src,
  });

  const fileCover = attachments?.find(file => file?.isCoverPhoto);

  useEffect(() => {
    (async () => {
      const attachmentsResponse = await getAttachmentsBgActor(String(item?.id));
      setAttachments(attachmentsResponse);
    })();
  }, []);

  return (
    <S.CardContainer selected={selected}>
      <S.CustomStack src={src as SRC_TYPES}>
        <Header
          colorSelectedFigurant={colorSelectedFigurant}
          colorUnavailableFigurant={colorUnavailableFigurant}
          figurantUnavailable={figurantUnavailable}
          item={item}
          missingInformation={missingInformation}
          showBlock={showBlock}
          src={src}
          statusColor={statusColor}
          updated_at={updated_at}
          name={name}
          fileCover={fileCover}
        />
        <MainContent
          colorSelectedFigurant={colorSelectedFigurant}
          colorUnavailableFigurant={colorUnavailableFigurant}
          extraUnavailable={extraUnavailable}
          figurantUnavailable={figurantUnavailable}
          missingInformation={missingInformation}
          name={name}
          renderInfo={renderInfo}
          selected={selected}
          src={src}
          submitBySrc={submitBySrc}
          isTextAvailable={isTextAvailable}
          type={type}
        />
      </S.CustomStack>
      <ActionBottom
        cardType={cardType}
        colorSelectedFigurant={colorSelectedFigurant}
        figurantCpf={figurantCpf}
        isAvailableToShowSelectButton={isAvailableToShowSelectButton}
        isDisabled={isDisabled}
        item={item}
        missingInformation={missingInformation}
        pathname={pathname}
        selected={selected}
        src={src as KeySrcTypes}
        submitBySrc={submitBySrc}
        type={type}
      />
      <Popover item={item} src={src} type={type} handleStatusFigurant={handleStatusFigurant} selected={selected} />
    </S.CardContainer>
  );
};
